import {JSX, lazy} from "react";
import FuzzySugeno from "../pages/FuzzySugeno";
import { Navigate } from "react-router-dom";
import FuzzyMamdhani from "../pages/FuzzyMamdhani";
import MachineLearningDasar from "../pages/MachineLearningDasar";

export interface RouteType {
  path: string;
  element: JSX.Element;
  layout: "default" | "blank";
}

export const routes: RouteType[] = [

  {
    path: "/tugas/sm1/kecerdasan-buatan/implementasi-fuzzy-sugeno",
    element: <FuzzySugeno />,
    layout: "blank",
  },
  {
    path: "/tugas/sm1/kecerdasan-buatan/implementasi-fuzzy-mamdhani",
    element: <FuzzyMamdhani />,
    layout: "blank",
  },
  {
    path: "/tugas/sm1/kecerdasan-buatan/implementasi-machine-learning",
    element: <MachineLearningDasar />,
    layout: "blank",
  },
  // {
  //   path: "*",
  //   element: <Navigate to="/tugas/sm1/kecerdasan-buatan/implementasi-fuzzy-sugeno" />,
  //   layout: "blank",
  // }

];

